__turbopack_context__.v({
  "button": "YxwxnG_button",
  "container": "YxwxnG_container",
  "isActive": "YxwxnG_isActive",
  "isVisible": "YxwxnG_isVisible",
  "moreWords": "YxwxnG_moreWords",
  "selectedWords": "YxwxnG_selectedWords",
  "toLkButton": "YxwxnG_toLkButton",
  "tooltip": "YxwxnG_tooltip",
  "tooltipDescription": "YxwxnG_tooltipDescription",
  "tooltipHeader": "YxwxnG_tooltipHeader",
  "tooltipTitle": "YxwxnG_tooltipTitle",
  "tooltipType": "YxwxnG_tooltipType",
  "word": "YxwxnG_word",
});
